const ICON_SCALE = 1.25;
const ICON_Y_AXIS_MARGIN = 4;

interface IconPosition {
  iconY: number;
  iconRight: number;
}

interface CalculateIconPositionProps {
  idx: number;
  chartWidth: number;
  iconHeight: number;
  iconWidth: number;
  insightIconTop: number;
  insightIconRight: number;
  yOffsetCount: number;
  minIconY?: number;
}

export const calculateIconPosition = ({
  idx,
  chartWidth,
  iconHeight,
  iconWidth,
  insightIconTop,
  insightIconRight,
  yOffsetCount,
  minIconY = 0,
}: CalculateIconPositionProps): IconPosition => {
  const iconOffsetY = (yOffsetCount + idx) * iconHeight * ICON_SCALE;
  const calculatedY =
    insightIconTop - iconHeight - ICON_Y_AXIS_MARGIN - iconOffsetY;
  const iconY = Math.max(minIconY, calculatedY);
  const maxIconRight = Math.max(0, chartWidth - iconWidth);
  const centeredIconRight = insightIconRight - iconWidth / 2;
  const iconRight = Math.min(Math.max(centeredIconRight, 0), maxIconRight);

  return { iconY, iconRight };
};
